import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from '@i18n/client';
import { Nullable } from '@interfaces/nullable';
import { toast } from 'react-toastify';

export const useRedirect = () => {
  const [isRedirecting, setIsRedirecting] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname;
  const { t } = useTranslation();

  const redirect = (
    url: Nullable<string>,
    withLocale = false,
    errorText?: string
  ) => {
    if (url) {
      setIsRedirecting(true);
      try {
        if (withLocale) {
          const localeMatch = pathname?.match(/^\/([a-z]{2})\//);
          const locale = localeMatch ? localeMatch[1] : 'ru';
          const finalUrl =
            url.startsWith(`/${locale}/`) || url.startsWith('/http')
              ? url
              : `/${locale}${url}`;

          navigate(finalUrl);
        } else {
          navigate(url);
        }
      } catch (error: unknown) {
        setTimeout(() => {
          setIsRedirecting(false);
        }, 5000);
        toast.error(errorText || t('redirectError'));
      }
    } else {
      toast.error(t('redirectError'));
    }
  };
  return { redirect, isRedirecting };
};
